var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"time-of-damage-header"},[_c('v-col',{staticClass:"header--content",attrs:{"cols":"12"}},[_c('h1',[_vm._v("Hasar Anında")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }